import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './email-reply-actions';
import type {EmailReplyAction} from './email-reply-actions';

export type EmailReplyState = {
    isOpen: boolean;
    replyToEmailId: string | null | undefined;
    isReplyingAll: boolean;
    onReplySuccess?: () => void;
    suggestedEmailReplyId?: string;
};

export const defaultEmailReplyState = {
    isOpen: false,
    replyToEmailId: null,
    isReplyingAll: false,
} as const;

export const emailReplyReducer = (
    state: EmailReplyState | null | undefined = defaultEmailReplyState,
    action: EmailReplyAction
): EmailReplyState => {
    switch (action.type) {
        case ActionTypes.EMAIL_REPLY_OPENED:
            return {
                ...state,
                isOpen: true,
                replyToEmailId: action.payload.replyToEmailId,
                isReplyingAll: action.payload.isReplyingAll,
                onReplySuccess: action.payload.onReplySuccess,
                suggestedEmailReplyId: action.payload.suggestedEmailReplyId,
            };
        case ActionTypes.EMAIL_REPLY_CLOSED:
            return defaultEmailReplyState;
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            const persistedState = action.payload;
            if (!persistedState || !persistedState.ui || !persistedState.ui.emailReplyModal) {
                // @ts-expect-error
                return state;
            }

            return persistedState.ui.emailReplyModal;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
